import React from 'react';

// ============================================
// ✅ Иконка узла учёта (ваш конкретный контур)
// ============================================
const MeteringNodeIcon = ({ className = "w-6 h-6", ...props }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={className}
            {...props}
        >
            <path
                d="M11.477 15.706q0 .95.417 1.84q.417.889 1.356 1.996l-.733.608q-1.046-1.121-1.546-2.198t-.5-2.215q0-.873.25-1.808q.248-.935.84-2.356q.562-1.379.765-2.126t.203-1.391q0-.931-.445-1.771T10.63 4.458l.708-.7Q12.473 4.846 13 5.873t.528 2.158q0 .76-.221 1.616t-.814 2.292q-.586 1.442-.802 2.252q-.215.809-.215 1.515m4.471.038q0 .95.42 1.84q.42.889 1.359 1.997l-.733.602q-1.046-1.121-1.549-2.195t-.503-2.213q0-.873.25-1.808q.249-.934.84-2.356q.562-1.378.765-2.126q.203-.747.203-1.39q0-.932-.442-1.772t-1.45-1.825l.702-.7q1.134 1.086 1.662 2.113Q18 6.94 18 8.07q0 .76-.221 1.616t-.814 2.292q-.586 1.442-.802 2.252q-.215.81-.215 1.515m-8.942 0q0 .95.42 1.84q.42.889 1.358 1.997l-.732.607q-1.046-1.12-1.549-2.198T6 15.775q0-.873.249-1.808q.249-.934.841-2.356q.562-1.378.765-2.126q.203-.747.203-1.39q0-.932-.443-1.772q-.442-.84-1.45-1.825l.702-.7Q8.002 4.884 8.53 5.911t.528 2.158q0 .76-.222 1.616q-.22.857-.813 2.292q-.586 1.442-.802 2.252q-.215.81-.215 1.515"
            />
        </svg>
    );
};

export default MeteringNodeIcon;